angular.module('unergie.main')
.controller('zendeskB2gCtrl', ($q, $scope, $stateParams, NgTableParams, AlertManager, AuthService, BoFeaturesService, ModalService, ApiAdmin,
    ErrorCatcher, myAccounts) => {
    $scope.canAccessZendeskB2G = BoFeaturesService.isFeatureOn('canAccessZendeskB2G')

    $scope.searchDateTooltip = 'Recherche de date avec opérateurs :\n' +
        '"12/09/2017" : le 12 sept\n' +
        '"<12/09/2017" : avant le 12 sept minuit\n' +
        '"<=12/09/2017" : avant le 12 sept inclus\n' +
        '">12/09/2017" : apres le 12 sept minuit\n' +
        '">=12/09/2017" : apres le 12 sept inclus\n'
    $scope.searchPDLTooltip = ''
    $scope.searchTextTooltip = ''
    $scope.main_topic_mapping = $q.defer()
    $scope.zendesk_b2g_status_mapping = [
        { id: '', title: 'Tous les non archvés' },
        { id: 'new', title: 'Nouveau' },
        { id: 'open', title: 'Ouvert' },
        { id: 'pending', title: 'En attente' },
        { id: 'solved', title: 'Résolu' },
        { id: 'closed', title: 'Archivé' },
    ]
    $scope.zendeskB2gIssues = null

    $scope.selectedFilter = $stateParams.status || null

    const auth = AuthService.getAuth()

    $scope.filters = [{
        label: 'Demandes ouvertes de mon organisation',
        value: null,
    }, {
        label: 'Demandes récemment mises à jour de mon organisation',
        value: 'lastUpdated',
    }, {
        label: 'En attente',
        value: 'statusWaiting',
    },
    {
        label: 'Demandes résolues',
        value: 'statusResolved',
    },
    ]

    $scope.parseFilter = () => {
        switch ($scope.selectedFilter) {
            case 'lastUpdated': return { updated_at: `>=${moment().subtract(14, 'days').format('DD/MM/YYYY')}` }
            case 'statusWaiting': return { status: 'pending' }
            case 'statusResolved': return { status: 'solved' }
            default: return null
        }
    }


    const formatMainTopic = (main_topic) => (main_topic && main_topic[1] && main_topic[0].toUpperCase() + main_topic.slice(1).replaceAll('_', ' ')) || (main_topic && main_topic[0].toUpperCase()) || ''


    const refresh = (params) => {
        $scope.refreshing = true
        const zendeskB2gParams = _.assign({}, params)
        zendeskB2gParams.filter = () => _.assign({}, $scope.parseFilter(), params.filter())
        return ApiAdmin.fetchZendeskB2gTickets(
            {
                page: zendeskB2gParams.page(),
                limit: zendeskB2gParams.count(),
                filter: zendeskB2gParams.filter(),
                sort: zendeskB2gParams.sorting(),
            }, auth.organization).$promise.then((response) => {
            const result = response.results
            $scope.zendeskB2gIssues.total = () => response.count
            const zendeskB2gIssuesMap = _.map(result, (issue) => {
                const fields = issue.fields.reduce((acc, field) => {
                    acc[field.label] = field.value
                    return acc
                }, {})
                return {
                    id: issue.id,
                    created_at: moment(issue.created_at).format('DD/MM/YYYY HH:mm'),
                    updated_at: moment(issue.updated_at).format('DD/MM/YYYY HH:mm'),
                    updated_at_original: issue.updated_at,
                    main_topic: formatMainTopic(fields.main_topic),
                    subject: issue.subject,
                    description: issue.description,
                    status: issue.status,
                    initiator: `${issue.requester ? `${issue.requester.name} @ ` : ''}${fields.adherent ? fields.adherent : ''}`,
                    prm: fields.prm,
                    id_case: fields.id_case,
                    url: issue.url.replace('api/v2', 'agent').replace('.json', ''),
                    changeStatusFields: {
                        newStatus: {
                            label: 'Nouveau statut',
                            type: 'select',
                            required: true,
                            enum: $scope.zendesk_b2g_status_mapping.map((v) => ({ value: v.id, label: v.title })).filter((s) => !['', 'new', issue.status].includes(s.value)),
                        },
                        newStatusComment: {
                            label: 'Commentaire',
                            type: 'text',
                        },
                    },
                }
            })
            $scope.zendeskB2gIssues.data = zendeskB2gIssuesMap

            return zendeskB2gIssuesMap
        })
        .catch((err) => {
            $scope.zendeskB2gIssues.data = null
            console.error(err)
            return AlertManager.error('Une erreur est intervenue lors de l’appel a Zendesk', 5000)
        })
        .finally(() => {
            $scope.refreshing = false
        })
    }

    $scope.renderTable = () => {
        $scope.zendeskB2gIssues = new NgTableParams({
            count: ($scope.zendeskB2gIssues != null ? $scope.zendeskB2gIssues.count() : undefined) || 12,
            filter: ($scope.zendeskB2gIssues != null ? $scope.zendeskB2gIssues.filter() : undefined) || {},
            sorting: ($scope.zendeskB2gIssues != null ? $scope.zendeskB2gIssues.sorting() : undefined) || { created_at: 'desc' },
        }, {
            counts: [12, 25, 50, 100],
            getData: refresh,
        })
    }

    $scope.fetchMainTopics = () => {
        $scope.loadingIssues = true
        return ApiAdmin.getZendeskB2gTopics().$promise.then((main_topics) => {
            $scope.main_topics = angular.fromJson(angular.toJson(main_topics))
            $scope.main_topic_mapping.resolve(_.map($scope.main_topics, (main_topic) => ({
                id: main_topic,
                title: formatMainTopic(main_topic),
            })))
        })
        .catch(ErrorCatcher)
        .finally(() => {
            $scope.loadingIssues = false
        })
    }

    $scope.fetchMainTopics()
    $scope.renderTable()

    $scope.expandIssue = function (issue) {
        issue.expanded = !issue.expanded
    }

    $scope.openNewZendeskB2gModal = () => {
        ModalService.openModal({ type: 'newZendeskB2gModal', size: 'md' }, { accounts: myAccounts }, $scope.renderTable)
    }

    $scope.openZendeskB2gCommentsModal = (issue) => {
        ModalService.openModal({ type: 'zendeskB2gCommentsModal', size: 'lg' }, { idZendeskB2g: issue.id, readOnly: false })
    }

    $scope.changeIssueStatus = (issue) => {
        issue.modifyingStatus = true
        const transitionLabel = $scope.zendesk_b2g_status_mapping.find((status) => status.id === issue.newStatus).title
        const comment = `Statut modifié par ${auth.user} => [${transitionLabel}]${issue.newStatusComment ? `, commentaire: "${issue.newStatusComment}"` : ''}`
        return ApiAdmin.updateZendeskB2gTicketStatus({ id: issue.id }, { newStatus: issue.newStatus, comment, updated_stamp: issue.updated_at_original }).$promise.then(() => {
            AlertManager.success('Statut modifié')
            $scope.renderTable()
        })
        .catch(ErrorCatcher)
        .finally(() => {
            issue.modifyingStatus = false
        })
    }
})
